/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import {
    List, Datagrid, TextField, FunctionField, SimpleList
} from 'react-admin';
import {
    useMediaQuery, makeStyles, FormControl, Select, MenuItem, InputLabel, Paper, Typography, Tooltip, Button
} from '@material-ui/core';
import { customTheme } from "./customTheme";
import CustomSearch from './components/CustomSearch';
import { useLocation } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import moment from 'moment';
import CustomFilter from './components/CustomFilter';
import ScrollableTable from './components/ScrollableTable';
import UseAnalyticsEvent from './utils/useAnalyticsEvent';
import CustomDateTimePicker from "./components/CustomDateTimePickerV4";
import ParkingSearchSelector from './components/ParkingSearchSelector';
import ImageGalleryDialogV2 from './components/ImageGalleryDialogV2';
import BrokenImageOutlinedIcon from '@material-ui/icons/BrokenImageOutlined';
import ShowTimePeriod from './components/ShowTimePeriod';
import queryString from 'query-string';
import { saveTokens } from './utils/saveTokens';
import { AnalyticDistributionImgs } from "./sharedData";
import downArrow from './images/down.png'
import sideArrow from './images/side.png'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Skeleton from '@material-ui/lab/Skeleton';
import notify from './components/CustomUseNotify';
import config from "./config.json"

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
    title: {
        fontSize: 13,
        color: customTheme.palette.secondary.main,
    },
    mainValue: {
        fontSize: 28,
        color: customTheme.palette.primary.main,
        fontWeight: customTheme.typography.fontWeightMedium
    },
    summaryBox: {
        padding: customTheme.spacing(3, 3),
    },
    twoColumnGrid: {
        padding: customTheme.spacing(1, 0, 2),
        display: "grid",
    },
    summaryVehicleIcon: {
        width: 18
    },
    summaryBoxLabel1: {
        fontSize: 12,
        color: "#A3BBD9",
        margin: customTheme.spacing(0, 2, 0, 1),
    },
    summaryBoxLabel2: {
        fontSize: 12,
        color: "#A3BBD9",
        margin: customTheme.spacing(0, 2, 0, 1),
    },
    paymentSummaryBoxLabel1: {
        fontSize: 12,
        color: customTheme.palette.grey[500],
    },
    summaryBoxValue1: {
        fontSize: 12,
        color: "#334D6E",
        fontWeight: customTheme.typography.fontWeightMedium
    },
    tooltip: {
        fontSize: 9,
        fontFamily: "Poppins-Regular",
        fontWeight: "normal"
    },
    flexContainer: {
        display: 'flex',
        alignItems: "center",
    },
});

const CATEGORY = "DASHBOARD LOGS SECTION";

const ACTIONS = {
    "CREATE": "#18cc69",
    "UPDATE": "#334d6e",
    "DELETE": "#de575e"
};

const progressBarColor = ["#16CC69", "#5E8DD3", "#334D6E", "#F7685B", "#16CC69", "#5E8DD3", "#334D6E", "#F7685B"]

let barrierSummaryInitState = {
    "data": {
        "Total Entry": {
            "types": {
                "Up Count": {
                    "count": 50,
                    "percentage": 50
                },
                "Down Count": {
                    "count": 50,
                    "percentage": 50
                },
            },
            "totalSum": 100
        },
        "Total Exit": {
            "types": {
                "Up Count": {
                    "count": 50,
                    "percentage": 50
                },
                "Down Count": {
                    "count": 50,
                    "percentage": 50
                },
            },
            "totalSum": 100
        },
    },
    "loading": true,
    "isInitState": true
}

let barrierGateWiseSummaryInitState = {
    "data": {
        "Gate 1": {
            "types": {
                "Up Count": {
                    "count": 50,
                    "percentage": 50
                },
                "Down Count": {
                    "count": 50,
                    "percentage": 50
                },
            },
            "totalSum": 100
        },
        "Gate 2": {
            "types": {
                "Up Count": {
                    "count": 50,
                    "percentage": 50
                },
                "Down Count": {
                    "count": 50,
                    "percentage": 50
                },
            },
            "totalSum": 100
        },
        "Gate 3": {
            "types": {
                "Up Count": {
                    "count": 50,
                    "percentage": 50
                },
                "Down Count": {
                    "count": 50,
                    "percentage": 50
                },
            },
            "totalSum": 100
        },
    },
    "loading": false,
    "isInitState": true
}

export const BarrierActivityList = props => {
    const eventTracker = UseAnalyticsEvent();
    const classes = useStyles();
    const location = useLocation();

    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : "";
    const [search, setSearch] = useState(prevSearch.inputSearch);
    let searchTypeState = ["Gate", "Device ID"];
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Gate");
    const [filterListValue, setFilterListValue] = useState(prevSearch.radioValue ? prevSearch.radioValue : null);
    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    const [showTiles, setShowTiles] = useState(true)
    const [barrierSummary, setBarrierSummary] = useState(barrierSummaryInitState)
    const [barrierGateWiseSummary, setBarrierGateWiseSummary] = useState(barrierGateWiseSummaryInitState)
    const [activityType, setActivityType] = useState(null)
    const [settingFilterFormat, setSettingFilterFormat] = useState({})
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});
    const [use24HourFormat] = useState(sessionStorage.getItem("use_24_hour_format") === "1");
    const [showTimeTillSeconds] = useState(sessionStorage.getItem("show_time_till_seconds") === "1");
    const [startDateTime, setStartDateTime] = useState(null);
    const [endDateTime, setEndDateTime] = useState(null);
    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));


    const filter = { ...settingFilterFormat, search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, start_time: startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss") : "", end_time: endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : "", access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined };

    let filterTypesInitState = [
        {
            filterType: "Activity",
            dataList: [{ name: "UP", id: 1 }, { name: "DOWN", id: 2 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
        {
            filterType: "Log Type",
            dataList: [{ name: "ENTRY", id: 1 }, { name: "EXIT", id: 2 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
        {
			resourcePath: "parkingDevices",
			filterType: "Entry Gate",
			filterParams: {
				access_key_id: currentParking.id,
				parking_info_id: currentParking.allZones ? currentParking.parking_info_id : null,
				sub_type: "CON-ENTRY"
			},
			dataList: [],
			searchList: [],
			listType: "Dynamic",
			resourceParam: "name",
			source: "name",
			showFilter: true,
			filterFormat: "Checkbox"
		},
		{
			resourcePath: "parkingDevices",
			filterType: "Exit Gate",
			filterParams: {
				access_key_id: currentParking.id,
				parking_info_id: currentParking.allZones ? currentParking.parking_info_id : null,
				sub_type: "CON-EXIT",
			},
			dataList: [],
			searchList: [],
			listType: "Dynamic",
			resourceParam: "name",
			source: "name",
			showFilter: true,
			filterFormat: "Checkbox"
		},
    ];

    const renderTime = time => {
        const secondsFormat = showTimeTillSeconds ? ":ss" : "";
        if (use24HourFormat) return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY ${use24HourFormat ? `HH:mm${secondsFormat}` : `hh:mm${secondsFormat} a`}`);
        return moment(time, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY hh:mm:ss A")
    };

    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };


    const getBarrierSummary = () => {
        setBarrierSummary({ loading: true, data: barrierSummaryInitState.data, isInitState: true })
        const params = {
            filter: JSON.stringify({
                access_key_id: currentParking.id,
                parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined,
                start_time: startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss") : "",
                end_time: endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : ""
            })
        }
        fetch(`${config.HOST_NAME}/crm/v3/barrierActivities/tiles?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
        }).then(response => {
            saveTokens(response)
            return response.json()
        })
            .then(responseJson => {
                if (responseJson.success) setBarrierSummary({ loading: false, data: responseJson.data, isInitState: false });
                else notify(responseJson.message, 'warning');
            })
            .catch((e) => {
                console.log(e)
                notify('Error Fetching Summary', 'warning')
            });
    }

    const getBarrierGateWiseSummary = () => {
        setBarrierGateWiseSummary({ loading: true, data: {}, isInitState: true })
        const params = {
            filter: JSON.stringify({
                access_key_id: currentParking.id,
                parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined,
                start_time: startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss") : "",
                end_time: endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : "",
                breakdown: activityType && activityType === "Total Entry" ? "ENTRY" : activityType && activityType === "Total Exit" ? "EXIT" : "",
            })
        }
        fetch(`${config.HOST_NAME}/crm/v3/barrierActivities/tiles/filter?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
        }).then(response => {
            saveTokens(response)
            return response.json()
        })
            .then(responseJson => {
                if (responseJson.success) setBarrierGateWiseSummary({ loading: false, data: responseJson.data, isInitState: false });
                else notify(responseJson.message, 'warning');
            })
            .catch((e) => {
                console.log(e)
                notify('Error Fetching Summary', 'warning')
            });
    }

    useEffect(() => {
        getBarrierSummary()
    }, [currentParking, startDateTime, endDateTime]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (activityType) getBarrierGateWiseSummary()
    }, [currentParking, startDateTime, endDateTime, activityType]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        let values = {}
        // Add more types based on the filters
        if (filterListValue) {
            for (let val in filterListValue) {
                if (filterListValue[val].filterType === "Activity") {
                    values = { ...values, activity: filterListValue[val].value ? filterListValue[val].value : undefined }
                }
                if (filterListValue[val].filterType === "Log Type") {
                    values = { ...values, log_type: filterListValue[val].value ? filterListValue[val].value : undefined }
                }
                if (filterListValue[val].filterType === "Entry Gate") {
                    values = { ...values, entry_ids:filterListValue[val].id ? JSON.stringify(filterListValue[val].id) : undefined }
                }
                if (filterListValue[val].filterType === "Exit Gate") {
                    values = { ...values, exit_ids:filterListValue[val].id ? JSON.stringify(filterListValue[val].id) : undefined }
                }
            }
            setSettingFilterFormat(values);
        }
        if (filterListValue === null) {
            setSettingFilterFormat({});
        }
    }, [filterListValue]) // eslint-disable-line react-hooks/exhaustive-deps

    React.useEffect(() => {
        eventTracker(CATEGORY, "DASHBOARD LOGS LIST");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return <div className={classes.list}>
        <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>
            {showFilter && <ParkingSearchSelector
                value={currentParking}
                onChange={onParkingChange}
                clearable={true}
                pathName={location.pathname}
            />}

            {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                    <InputLabel>Zone Name</InputLabel>
                    <Select
                        value={currentParking.allZones ? "All" : currentParking.id}
                        onChange={onZoneChange}
                        label="Zone Name"
                        variant="outlined"
                    >
                        <MenuItem value="All">All</MenuItem>
                        {finalZones.map((zone, index) => (
                            <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            }
        </div>

        <div className='customStyleForDataSearchDiv'>
            <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
            <CustomDateTimePicker startDateTime={startDateTime} setStartDateTime={setStartDateTime} endDateTime={endDateTime} setEndDateTime={setEndDateTime} />
            <CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} pathName={location.pathname} />
        </div>
        <ShowTimePeriod startDateTimeFilter={startDateTime} endDateTimeFilter={endDateTime} showTiles={showTiles} setShowTiles={setShowTiles} />

        {showTiles &&
            <>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", justifyContent: "space-between", gap: 15, marginTop: 10 }}>
                    {
                        Object.keys(barrierSummary.data).map((value) => (
                            <SummaryCard
                                title={value}
                                data={barrierSummary.data[value]["types"]}
                                getValue={data => barrierSummary.data[value]["totalSum"]}
                                getDistributedLabels={data => Object.keys(data).map(val => AnalyticDistributionImgs[val]?.["label"])}
                                getDistributedValues={data => Object.keys(data).map(val => data[val].count ? data[val].count : 0)}
                                getDistributedIcons={data => Object.keys(data).map(val => AnalyticDistributionImgs[val]?.["img"])}
                                getDistributedValuePercentage={data => Object.keys(data).map(val => data[val].percentage ? data[val].percentage : 0)}
                                getDistributedPercentage={data => Object.keys(data).map((val, i) => {
                                    return { percentage: data[val].percentage ? data[val].percentage.toFixed(2) : 0, color: progressBarColor[i] }
                                })}
                                loading={barrierSummary.loading}
                                showDonutChart={true}
                                showProgressBar={true}
                                activityType={activityType}
                                setActivityType={(type) => setActivityType(type)}
                            />
                        ))
                    }
                </div>

                {barrierGateWiseSummary && Object.keys(barrierGateWiseSummary.data)[0] && activityType &&
                    <>
                        <div className='secondaryColor fontWeightSemiBold' style={{ fontSize: 14, marginTop: 10 }}>{`Gate Wise ${activityType} Breakdown`}</div>
                        <div className='vehicleSummaryCardScroll'>
                            <div className='vehicleSummaryCardFlexScroll'>
                                {
                                    Object.keys(barrierGateWiseSummary.data).map((value) => (
                                        <SummaryCard
                                            title={value}
                                            data={barrierGateWiseSummary.data[value]["types"]}
                                            getValue={data => barrierGateWiseSummary.data[value]["totalSum"]}
                                            getDistributedLabels={data => Object.keys(data).map(val => AnalyticDistributionImgs[val]?.["label"])}
                                            getDistributedValues={data => Object.keys(data).map(val => data[val].count ? data[val].count : 0)}
                                            getDistributedIcons={data => Object.keys(data).map(val => AnalyticDistributionImgs[val]?.["img"])}
                                            getDistributedValuePercentage={data => Object.keys(data).map(val => data[val].percentage ? data[val].percentage : 0)}
                                            getDistributedPercentage={data => Object.keys(data).map((val, i) => {
                                                return { percentage: data[val].percentage ? data[val].percentage.toFixed(2) : 0, color: progressBarColor[i] }
                                            })}
                                            loading={barrierSummary.loading}
                                            showDonutChart={true}
                                            showProgressBar={true}
                                            activityType={activityType}
                                        />
                                    ))
                                }
                            </div>
                        </div>
                    </>
                }

                {barrierGateWiseSummary.loading &&
                    <>
                        <Skeleton variant="text" height={22} width="200px" style={{ marginTop: "10px" }} />
                        <div className='vehicleSummaryCardScroll'>
                            <div className='vehicleSummaryCardFlexScroll'>
                                <SummaryCard
                                    title={""}
                                    data={""}
                                    getValue={data => ""}
                                    getDistributedLabels={data => ""}
                                    getDistributedValues={data => ""}
                                    getDistributedIcons={data => ""}
                                    getDistributedValuePercentage={data => ""}
                                    getDistributedPercentage={data => Object.keys(data).map((val, i) => {
                                        return ""
                                    })}
                                    loading={true}

                                />
                            </div>
                        </div>
                    </>
                }
            </>
        }


        <List
            {...props}
            style={{ marginTop: 10 }}
            title="Barrier Activity"
            bulkActionButtons={false}
            exporter={false}
            filter={filter}
            empty={false}
            pagination={<CustomPagination />}
            actions={false}
        >
            {isSmallDevice ?
                <SimpleList
                    primaryText={record => record.username}
                    secondaryText={record => (<div>
                        {record.section && <div><span style={{ color: "#5a5a5a" }}>Section: </span>{record.section}</div>}
                        {record.action && <div style={{ color: ACTIONS[record.action] }}><span style={{ color: "#5a5a5a" }}>Action: </span>{record.action}</div>}
                        {record.time && <div><span style={{ color: "#5a5a5a" }}>Timestamp: </span>{renderTime(record["time"])}</div>}
                    </div>)}
                    onContextMenu={event => event.preventDefault()}
                    linkType={false}
                    rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                />
                :
                <Datagrid component={ScrollableTable}>
                    <FunctionField
                        label="Image"
                        render={(record) => record && record.image ?
                            <ImageGalleryDialogV2
                                thumbnail={true}
                                thumbnailUrl={record.image_thumbnail}
                                record={record}
                                getImages={(record) => {
                                    if (record.image) {
                                        return [record.image];
                                    }
                                }}
                            />
                            :
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", border: "1px solid #BDBDBD", minWidth: "50px", width: "60px", borderRadius: 5, height: "40px" }}>
                                <BrokenImageOutlinedIcon />
                            </div>
                        }
                    />
                    <TextField source="device_id" label="Device ID" sortable={false} />
                    <TextField source="gate_id" label="Gate" sortable={false} />
                    <TextField source="activity" label="Activity" sortable={false} />
                    <TextField source="log_type" label="Log Type" sortable={false} />
                    <TextField source="timestamp" label="Timestamp" />
                </Datagrid>
            }
        </List>
    </div>
};

function SummaryCard({ title, loading, data, getValue, getDistributedValues, getDistributedLabels, getDistributedIcons, getDistributedPercentage, getDistributedValuePercentage, getSubPercentage, getDistributedAmount, showDonutChart, clickable, showProgressBar = false, getDistributedCount, showTooltip = false, getNestedTypes = null, isPaymentType = true, activityType, setActivityType, style }) {
    const classes = useStyles();

    return <Paper style={{ position: "relative", display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', boxShadow: "0px 4px 15px #0000001a", padding: "14px 20px 18px 20px", cursor: clickable ? "pointer" : "", ...style }}>
        <div style={{ flex: 1 }}>
            <div>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography className={classes.title} style={{ textTransform: "capitalize" }}>{title}</Typography>

                    {getValue(data) > 0 && setActivityType &&
                        <Button style={{ minWidth: "80px", background: "none", border: "none", cursor: "pointer", backgroundColor: "#109CF11A", color: "#5E8DD3", padding: "1px 12px", borderRadius: 2, fontSize: 9, textTransform: "none", fontWeight: "normal" }} onClick={() => setActivityType(activityType === title && activityType ? null : activityType === null ? title : activityType && activityType !== title ? title : null)}><p style={{ lineHeight: 0, marginRight: 5 }}>{activityType === title ? "Details" : "Gate Wise Filter"}</p>
                            <img src={activityType === title ? downArrow : sideArrow} alt='arrow' />
                        </Button>
                    }
                </div>
                {
                    !loading && data ?
                        <div style={{ display: "flex", gap: 10, alignItems: getSubPercentage && (getSubPercentage(data) || getSubPercentage(data) === 0) ? "center" : "", flexWrap: "wrap" }}>
                            {getDistributedCount && getDistributedCount(data) && <Typography className={classes.mainValue} style={{ color: "#334D6E", marginRight: 10 }}>{getDistributedCount(data)}</Typography>}
                            <Typography className={classes.mainValue}>{["Amount"].includes(title) || ["Amount"].includes(activityType) ? "₹" : ""} {getValue(data)}</Typography>
                            {getSubPercentage && (getSubPercentage(data) || getSubPercentage(data) === 0) &&
                                <div style={{ display: "flex", alignItems: "center", backgroundColor: "#18CC6919", fontSize: 9, color: "#18CC69", padding: "0px 10px", height: 15, borderRadius: 10, fontFamily: "Poppins-SemiBold" }}>
                                    {getSubPercentage(data)}%
                                </div>
                            }
                        </div>
                        :
                        !loading && !data ?
                            <div style={{ display: "flex", gap: 10, alignItems: getSubPercentage && (getSubPercentage(data) || getSubPercentage(data) === 0) ? "center" : "", flexWrap: "wrap" }}>
                                <Typography className={classes.mainValue}>{["Amount"].includes(title) || ["Amount"].includes(activityType) ? "₹" : ""} {getValue(data) ? getValue(data) : 0}</Typography>
                            </div>
                            :
                            <Skeleton variant="text" height={42} width="50px" />
                }
            </div>
            {
                !loading && data ? getDistributedLabels(data).map((dL, i) => (
                    <div>
                        <div key={dL} className={classes.flexContainer}>
                            <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                                <img className={classes.summaryVehicleIcon} src={getDistributedIcons(data)[i]} alt={dL} />
                                <Typography className={classes.summaryBoxLabel1}>{dL}:</Typography>
                            </div>
                            <div style={{ flex: 1, display: "flex", justifyContent: "flex-end", alignItems: "flex-end", gap: 10, flexWrap: "wrap" }}>
                                <Typography className={classes.summaryBoxValue1}>{["Amount"].includes(title) || ["Amount"].includes(activityType) ? "₹" : ""} {getDistributedValues(data)[i]}</Typography>

                                {isPaymentType && getDistributedAmount && getDistributedAmount(data) && <>
                                    <Typography className={classes.summaryBoxValue1} style={{ color: "#18CC69" }}>₹ {getDistributedAmount(data)[i].toFixed(2)}</Typography>                            </>
                                }
                                {!["Manual"].includes(dL) && getDistributedValuePercentage && getDistributedValuePercentage(data) && <>
                                    <Typography className={classes.summaryBoxValue1} style={{ color: "#18CC69", fontSize: 9 }}>{getDistributedValuePercentage(data)[i].toFixed(2)}%</Typography>
                                    {showTooltip && <Tooltip arrow title={`This percentage is the overall share for this gate for ${dL}`} classes={{ tooltip: classes.tooltip }}><InfoOutlinedIcon style={{ fontSize: 12, color: "#888" }} /></Tooltip>}
                                </>
                                }
                            </div>
                        </div>

                        {getNestedTypes && getNestedTypes(data) !== null &&
                            [Object.keys(getNestedTypes(data))[i]].map((val) => (
                                <>
                                    {getNestedTypes(data)[val]["types"] && Object.keys(getNestedTypes(data)[val]["types"]).map((subType) => (
                                        <div key={subType} className={classes.flexContainer} style={{ marginLeft: 20 }}>
                                            <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                                                <img className={classes.summaryVehicleIcon} src={AnalyticDistributionImgs[subType]?.["img"]} alt={subType} />
                                                <Typography className={classes.summaryBoxLabel1}>{subType}:</Typography>
                                            </div>
                                            <div style={{ flex: 1, display: "flex", justifyContent: "flex-end", alignItems: "flex-end", gap: 10, flexWrap: "wrap" }}>
                                                <Typography className={classes.summaryBoxValue1}>{getNestedTypes(data)[val]["types"] && getNestedTypes(data)[val]["types"][subType]["count"] ? `${getNestedTypes(data)[val]["types"][subType]["count"]}` : '0'} </Typography>
                                                {isPaymentType && <Typography className={classes.summaryBoxValue1} style={{ color: "#18CC69" }}>{getNestedTypes(data)[val]["types"] && getNestedTypes(data)[val]["types"][subType]["amount"] ? `₹ ${getNestedTypes(data)[val]["types"][subType]["amount"].toFixed(2)}` : '₹ 0'} </Typography>}
                                                <Typography className={classes.summaryBoxValue1} style={{ color: "#18CC69", fontSize: 9 }}>{getNestedTypes(data)[val]["types"] && getNestedTypes(data)[val]["types"][subType]["percentage"] ? getNestedTypes(data)[val]["types"][subType]["percentage"].toFixed(2) : '0'}%</Typography>
                                            </div>
                                        </div>
                                    ))}
                                </>
                            ))
                        }


                    </div>
                )) :
                    !loading && !data ? null
                        :
                        ["50", "40"].map((width, index) => (
                            <Skeleton variant="text" width={width} height={18} key={index} />
                        ))
            }
        </div>

        {showProgressBar && data && getDistributedPercentage &&
            <div className="horizontal-bar" style={{ position: "absolute", bottom: 0, left: 0, width: "100%" }}>
                {getDistributedPercentage(data).map((item, index) => (
                    <Tooltip arrow title={`${item.percentage}%`} classes={{ tooltip: classes.tooltip }}>
                        <div key={index} className="bar-segment" style={{ width: `${item.percentage}%`, backgroundColor: item.color }}>
                        </div>
                    </Tooltip>
                ))}
            </div>
        }
    </Paper>

}